import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import { allowedExchangeMethodsIncludesSomeVariantsType } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/helpers'

const ExchangeOrdersAutomaticCreationSelector = ({
  allowedPreferences,
  allowedExchangeMethods,
  exchangeOrdersAutomaticCreation,
  setExchangeOrdersAutomaticCreation,
  disabled = false,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !allowedPreferences.includes(preferences.exchangeOrdersAutomaticCreation) ||
    !allowedExchangeMethodsIncludesSomeVariantsType(allowedExchangeMethods)
  ) {
    return null
  }

  return (
    <ComboBox
      label={t('Nuevos productos solicitados')}
      value={exchangeOrdersAutomaticCreation}
      handleChange={e => setExchangeOrdersAutomaticCreation(e.target.value)}
      menuItems={[
        {
          label: t('Automatizar cobros y envíos (Crear nuevo pedido)'),
          value: exchangeOrdersAutomaticCreationValues.automatic,
        },
        { label: t('Gestionar cobros y envíos a mano'), value: exchangeOrdersAutomaticCreationValues.manual },
      ]}
      fullWidth
      disabled={disabled}
    />
  )
}

export default ExchangeOrdersAutomaticCreationSelector
